import {Checkbox} from './Checkbox';
import {is_function} from '../../../Helpers/js/simple.functions';

export class CheckboxGroup {
    constructor(checkboxDomNodes, onChange, noAnswerId, maxAnswers) {
        this.onChangeOriginal = onChange;
        this.checkboxes = checkboxDomNodes.map(chechbox => new Checkbox(chechbox, this.answersChanged.bind(this)));
        this.noAnswerCheckbox = this.getOptionById(noAnswerId);
        this.maxAnswers = maxAnswers;
        if (this.isNoAnswerChecked()) {
            this.disableAllOtherCheckboxesByNoAnswer();
        }
    }

    isNoAnswerChecked() {
        return (this.noAnswerCheckbox && this.noAnswerCheckbox.isChecked());
    }

    answersChanged(event, checkbox) {
        if (checkbox == this.noAnswerCheckbox) {
            if (this.isNoAnswerChecked()) {
                this.disableAllOtherCheckboxesByNoAnswer();
            } else {
                this.enableAllCheckboxes();
            }
        } else {
            this.handleMaxAnswers();
        }

        if (is_function(this.onChangeOriginal)) {
            this.onChangeOriginal(event);
        }
    }

    countAnswers() {
        return this.checkboxes.filter(checkbox => checkbox.isChecked()).length;
    }

    disableAllOtherCheckboxesByNoAnswer() {
        this.checkboxes.map(checkbox => checkbox != this.noAnswerCheckbox && checkbox.setDisabled());
    }

    disableAllUncheckedCheckboxes() {
        this.checkboxes.map(checkbox => !checkbox.isChecked() && checkbox.setDisabled());
    }

    enableAllCheckboxes() {
        if (this.isNoAnswerChecked()) {
            return;
        }

        if (this.maxAnswers > 0 && this.countAnswers() >= this.maxAnswers) {
            return;
        }

        this.checkboxes.map(checkbox => checkbox.isDisabled() && checkbox.setEnabled());
    }

    getOptionById(id) {
        return this.checkboxes.find(checkbox => checkbox.getValue() == id);
    }

    handleMaxAnswers() {
        if (!this.maxAnswers) {
            return;
        }

        if (this.countAnswers() >= this.maxAnswers) {
            this.disableAllUncheckedCheckboxes();
        } else {
            this.enableAllCheckboxes();
        }
    }
}